import { render, staticRenderFns } from "./payitem.vue?vue&type=template&id=2bb689f4&scoped=true&"
import script from "./payitem.vue?vue&type=script&lang=js&"
export * from "./payitem.vue?vue&type=script&lang=js&"
import style0 from "./payitem.vue?vue&type=style&index=0&id=2bb689f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb689f4",
  null
  
)

export default component.exports